<template>
  <div class="agreement-carrier-message-container" v-if="alertMessage">
    <div class="agreement-heading"> {{alertMessage}} </div>

    <div class="mt-2 mb-2 agreement-carrier-price-container">
      <p> Our comprehensive service rates are meticulously designed to encompass a wide array of essential fees, ensuring that every aspect of our members' welfare and administrative efficiency is thoroughly addressed. These rates include Union Health & Welfare Contributions <strong>(${{l713NetPrice}}),</strong> reflecting commitment to the health and well-being of the union members by providing them with the necessary medical and wellness support.</p>

      <p>In addition to health contributions, the rates encompass Union Dues, allocated at <strong>$25.00,</strong> which play a crucial role in supporting the overall functioning and advocacy efforts of the union. These dues are instrumental in ensuring that the union can effectively represent and champion the interests of its members, providing a strong collective voice in all pertinent matters.</p>

      <p>Furthermore, our rates include Annuity Fund Contributions, amounting to <strong>$10.00,</strong> aimed at providing long-term financial security. This ensures that our members can look forward to a secure and well-planned future after their years of dedicated service.</p>

      <p>To maintain operational excellence, we also incorporate Billing Fees <strong>($30.00),</strong> ensuring that all necessary administrative functions are managed efficiently and streamlined to support seamless operations. These fees are essential for maintaining the infrastructure and day-to-day activities of the organization.</p>

      <p>Moreover, Association Member Fees-Dues, set at (Single <strong>$50,</strong> Member+Spouse <strong>$100,</strong> Member+Child(ren) <strong>$100,</strong> Family <strong>$150</strong>), are included to support the collective activities and benefits provided to all members of the association. These fees facilitate various programs, events, and initiatives that enhance the overall member experience and foster a sense of community and collaboration.</p>

      <p>Lastly, the rates account for Independent Marketer Fees (based on the tier structure), these average between <strong>$77.00</strong> and <strong>$150.00</strong>, ensuring that our marketing efforts are professionally managed and executed to the highest standards. These fees enable us to maintain a strong presence and effectively communicate our value proposition to current and potential members.</p>

      <p>Collectively, these thoughtfully integrated contributions and fees provide a comprehensive and supportive environment for all our members, ensuring that their needs are met with the highest level of dedication and professionalism.</p>
    </div>
  </div>
</template>

<script>
export default {
name: "CarrierMessageAlert",
  props: {
    alertMessage: {
      type: String
    },
    isL713Plan: {
      type: Boolean
    },
    l713NetPrice: {
      type: Number
    },
    isAgreementPage: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style scoped>
.agreement-heading {
  font-weight: 700;
  margin-bottom: 1rem;
  padding-top: 10px;
}

.agreement-carrier-message-container {
  padding: 10px 20px;
  margin-top: 15px;
  text-transform: capitalize;
  font-size: 15px;
  width: 100%;
  border: 1px solid #ddd;
}

.agreement-carrier-price-container {
  text-align: justify;
}
</style>